import React, { useContext, useEffect, useRef, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { sendMobileNumber, sendVerificationCode } from '../../../service/userService';
import MainContext from './../../context/mainContext';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';

const LoginPage2 = ({ setPage, mobileNumberRef, remainingTimeRef, closeLoginModal }) => {

    const regix = /^[0-9]{6}$/;
    const [isLoading, setIsLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [isValid, setIsValid] = useState(false);
	const textInputRef = useRef(null);
    const [verificationCode, setverificationCode] = useState('');
    const [countWrong, setCountWrong] = useState(false);

    const { addToast } = useToasts()
    const context = useContext(MainContext)
    const executeTime = (soconds) => {
        return {
            minutes: Math.floor(soconds / 60),
            seconds: soconds % 60
        }
    }

    const [time, setTime] = useState({
        minutes: executeTime(remainingTimeRef.current).minutes,
        seconds: executeTime(remainingTimeRef.current).seconds,
    })


    const clickRef = useRef(null);

    useEffect(() => {
        const timer = setInterval(() => {
            let newTime = executeTime(remainingTimeRef.current)
            setTime({
                seconds: newTime.seconds,
                minutes: newTime.minutes
            })

            remainingTimeRef.current -= 1;
        }, 1000);
        return () => clearInterval(timer);
    }, [remainingTimeRef]);

    // useEffect(() => {
    //     if (verificationCode.length === 6) {
    //         clickRef.current.click()

    //     }
    // }, [verificationCode])

    const getCodeAgain = async (event) => {
        event.preventDefault();
        try {
            setResendLoading(true);
            const { status, data } = await sendMobileNumber(mobileNumberRef.current);
            if (status === 201) {
                remainingTimeRef.current = Math.floor(data.remainingSeconds);
                setResendLoading(false);
                setCountWrong(false);
                setverificationCode('');
                setIsValid(false);
                textInputRef.current.focus();
            }
        } catch (err) {

        }

    }

    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (isValid) {
                setIsLoading(true);
                const info = {
                    mobileNumber: mobileNumberRef.current,
                    vcode: verificationCode,

                }
                const { status, data } = await sendVerificationCode(info);
                if (status === 201) {
                    if (data.message === 'Logged in!') {
                        localStorage.setItem('token', data.token);
                        context.login(data.user);
                        addToast('ورود با موفقیت انجام شد', {
                            appearance: 'success',
                            autoDismiss: true,
                        })
                        closeLoginModal();
                    }
                    else {
                        setPage(3);
                    }
                }
            }

        } catch (err) {
            if (err.response && err.response.status === 429) {
                setCountWrong(true);
                setIsLoading(false);
                addToast("سقف تعداد ورود مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 404) {
                setIsLoading(false);
                addToast("زمان مجاز به اتمام رسیده است", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                setverificationCode('');
                setIsValid(false);
            }
            else if (err.response && err.response.status === 401) {
                setIsLoading(false);
                addToast("کد تایید اشتباه است", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                setverificationCode('');
                setIsValid(false);
            }
        }
    }

    const getStatusOfInput = () => {
		if(isValid){
			return 'form-control text-center mx-auto is-valid'
		}
		else{
			return 'form-control text-center mx-auto is-invalid'
		}
							
	}

    useEffect(() => {
		textInputRef.current.focus();
	},[]);
    
    return (
        <div>
            <div>
                <div className=" mb-3 mt-2">
                    <p className="text-center">
                        <span className="text-dark" style={{ fontSize: '1.2rem' }}>
                            <i className="fa fa-envelope-o text-dark"
                                style={{ fontSize: '1.4rem', position: 'relative', top: '5px', left: '10px' }}>
                            </i>
                            {mobileNumberRef.current}</span>
                    </p>
                    <div className="text-center mb-2">
                        <span className="text-success">
                            کد تایید با پیامک برای شما ارسال شد
                    </span>
                    </div>
                    <input
                        type="text"
                        autoComplete="off"
                        style={{ direction: 'ltr', width: '220px' }}
                        className={getStatusOfInput()}
                        ref={textInputRef}
                        id="verificationCode"
                        name="verificationCode"
                        placeholder="کد تایید 6 رقمی"
                        value={verificationCode}
                        onChange={(e) => {
                            if (regix.test(digitsFaToEn(digitsArToEn(e.target.value))))
                            setIsValid(true);
                            else
                            setIsValid(false);
                            setverificationCode(digitsFaToEn(digitsArToEn(e.target.value)));

                        }}
                        onBlur={() => {
                            if (verificationCode !== '') {
  
                            }
                        }}
                    />
                </div>
                <section className="mt-2 mb-4">
                    <div className="text-center ">
                        <button
                            ref={clickRef}
                            type="button"
                            className="btn btn-success px-2 py-1 mx-auto" style={{ width: '140px' }}
                            disabled={(time.minutes <= 0 && time.seconds <= 0) || countWrong || isLoading || !isValid}
                            onClick={submitHandler}
                        >
                            {
                                isLoading &&
                                <i  className= 'spinner-border spinner-border-sm operator-button mr-2'
                                    style={{position:'relative', bottom:'3px'}}
                                ></i>
                            }
                            ورود
                    </button>
                    </div>
                </section>
                <div className="text-center pb-3">
                    <span className="text-dark mx-auto text-center">
                        {
                            (time.minutes <= 0 && time.seconds <= 0) ?
                                <form onSubmit={getCodeAgain}>
                                    <button type="submit" className="btn btn-secondary"
                                        disabled={resendLoading}
                                    >
                                    {
                                        resendLoading &&
                                        <i  className= 'spinner-border spinner-border-sm operator-button mr-2'
                                            style={{position:'relative', bottom:'3px'}}
                                        ></i>
                                    }
                                        ارسال دوباره
                                    <i className="fa fa-undo ml-2 mr-1"></i>
                                    </button>
                                </form>
                                :
                                <React.Fragment>
                                    <span>{("0" + time.minutes).slice(-2)}</span>
                                    <span className="mx-1">:</span>
                                    <span>{("0" + time.seconds).slice(-2)}</span>
                                </React.Fragment>
                        }
                    </span>
                </div>
            </div>
        </div>
    );
}

export default LoginPage2;